import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './EasyCancel.styled';
import { Tooltip } from '../../../atoms/Tooltip';
import { dispatchCustomEvent } from '../../../utils/dispatchCustomEvent';
import { EVENT } from '../../../models/Event';
import { ANALYTICS_EVENT_NAME } from '../../../models/Analytics';

/**
 * Part of the easy cancel experiment, CL-53015
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EasyCancelWithTooltip = () => {
  const {
    t
  } = useTranslation('blocks.donation');
  const iconRef = useRef(null);
  const hasTrackedTooltipView = useRef(false);
  const onOpenChange = useCallback(isOpen => {
    if (isOpen && !hasTrackedTooltipView.current) {
      hasTrackedTooltipView.current = true;
      dispatchCustomEvent(EVENT.ANALYTICS_TRACK_EVENT, {
        trackingId: 'easy cancel tooltip viewed',
        eventName: ANALYTICS_EVENT_NAME.COMPONENT_VIEWED
      });
    }
  }, []);
  return /*#__PURE__*/_jsx(Styled.TooltipContainer, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      text: t('EasyCancelTooltip.text', "You're always in control of your recurring donations. You can edit, pause, or cancel anytime through your account settings."),
      arrowAnchorRef: iconRef,
      onOpenChange: onOpenChange,
      children: /*#__PURE__*/_jsxs("span", {
        children: [t('EasyCancelTooltip.label', 'Can I cancel my recurring donation?'), /*#__PURE__*/_jsx(Styled.IconWrapper, {
          ref: iconRef,
          children: /*#__PURE__*/_jsx(Styled.TooltipInfoIcon, {
            width: "24",
            height: "24",
            "aria-hidden": true
          })
        })]
      })
    })
  });
};
/**
 * Part of the easy cancel experiment, CL-53015
 */
export const EasyCancelLink = ({
  children
}) => /*#__PURE__*/_jsx(Styled.Link, {
  href: "https://prosupport.gofundme.com/hc/en-us/articles/37288771870619-Edit-update-or-cancel-your-recurring-donation",
  target: "_blank",
  rel: "noopener noreferrer",
  onClick: () => dispatchCustomEvent(EVENT.ANALYTICS_TRACK_EVENT, {
    trackingId: 'easy cancel link clicked',
    eventName: ANALYTICS_EVENT_NAME.LINK_CLICKED
  }),
  children: children
});